import React from "react";
import { Navigate, useLocation } from "react-router";
import Recommendations from "./Recommendations";

export default function RecommendationsPage() {
    const location = useLocation();

    if (!location.state || !location.state.recommendations || !location.state.name) {
        return <Navigate to="/" replace={true} />;
    }

    return <Recommendations recommendations={location.state.recommendations} name={location.state.name}/>;
}
